import React from 'react';
import useStyles from '../styles';
import { Typography } from '@mui/material';
import { useStore } from 'src/stores';
import { observer } from 'mobx-react-lite';
import RippleEffect from 'src/components/general/RippleEffect';
import { ExpandedTooltip } from '@livable/saas-react-components';
import { useTranslation } from 'react-i18next';
import { RESIDENCY_STATUS_KEY_VALUES } from 'src/constants/residency';
export const OccupancyCell = observer(_ref => {
  var _store$homeDashboardS, _store$homeDashboardS2, _params$row, _params$row$unitData, _params$row$unitData2, _params$row$unitData3, _params$row2, _params$row3, _params$row$unitData4;
  let params = _ref.params,
    setMmodalTempData = _ref.setMmodalTempData;
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", null, ((_store$homeDashboardS = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS === void 0 ? void 0 : _store$homeDashboardS.companyFeatureSet.isAppfolio) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ExpandedTooltip, {
    type: "grey",
    title: 'Occupancy value is imported from AppFolio and cannot be edited here. Please update it in AppFolio.',
    placement: "top"
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.tooltipContent
  }, /*#__PURE__*/React.createElement(RippleEffect, {
    className: "".concat(classes.cellContent, " cellContent")
  }, params.row.occupancy)))), !((_store$homeDashboardS2 = store.homeDashboardStore.getCurrentCompany) !== null && _store$homeDashboardS2 !== void 0 && _store$homeDashboardS2.companyFeatureSet.isAppfolio) && /*#__PURE__*/React.createElement(React.Fragment, null, !params.row.accountId && /*#__PURE__*/React.createElement("div", {
    onClick: event => {
      if (store.company.companyFeatureStore.disableUnitOccupancyChange) return;
      event.preventDefault();
      event.stopPropagation();
      setMmodalTempData({
        unitname: params.row.unitName,
        occupancy: params.row.occupancy,
        unitData: [params.row.unitData],
        rowData: params.row
      });
      store.residencies.showOccupancyUpdateModal(true);
      setTimeout(() => {
        document.getElementById('DGOccupancyUpdateModal').click();
      }, 0);
    }
  }, /*#__PURE__*/React.createElement(RippleEffect, {
    className: "".concat(classes.cellContent, " cellContent")
  }, params.row.occupancy)), params.row.accountId && /*#__PURE__*/React.createElement(ExpandedTooltip, {
    type: "grey",
    title: (params === null || params === void 0 || (_params$row = params.row) === null || _params$row === void 0 ? void 0 : _params$row.status) === RESIDENCY_STATUS_KEY_VALUES.Future ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
      variant: "h6",
      color: "white"
    }, t('add_new_property_flow.reminder')), /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      color: "white"
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "h6",
      color: "white",
      component: 'span'
    }, "".concat(params.row.occupancy, "/").concat((_params$row$unitData = params.row.unitData) === null || _params$row$unitData === void 0 ? void 0 : _params$row$unitData.occupancy, " -")), ' ', "The first value represents the", ' ', /*#__PURE__*/React.createElement(Typography, {
      variant: "h6",
      color: "white",
      component: 'span'
    }, "resident occupancy"), ", which is set to ", "".concat(params.row.occupancy), ". The second value corresponds to the", ' ', /*#__PURE__*/React.createElement(Typography, {
      variant: "h6",
      color: "white",
      component: 'span'
    }, "unit occupancy"), ", set to ", "".concat((_params$row$unitData2 = params.row.unitData) === null || _params$row$unitData2 === void 0 ? void 0 : _params$row$unitData2.occupancy), ". If a resident\u2019s enrollment is scheduled for a future date and they will not participate in the upcoming allocation cycle, the", ' ', /*#__PURE__*/React.createElement(Typography, {
      variant: "h6",
      color: "white",
      component: 'span'
    }, "unit occupancy value"), ' ', "(", "".concat((_params$row$unitData3 = params.row.unitData) === null || _params$row$unitData3 === void 0 ? void 0 : _params$row$unitData3.occupancy), ") will be used in the occupancy calculations. However, if the resident\u2019s enrollment date falls", ' ', /*#__PURE__*/React.createElement(Typography, {
      variant: "h6",
      color: "white",
      component: 'span'
    }, "within"), ' ', "the allocation cycle, the", ' ', /*#__PURE__*/React.createElement(Typography, {
      variant: "h6",
      color: "white",
      component: 'span'
    }, "resident occupancy value"), ' ', "(", "".concat(params.row.occupancy), ") will be applied instead."), /*#__PURE__*/React.createElement(Typography, {
      variant: "h6",
      color: "white"
    }, "NOTE: Please use row menu to update each occupancy value accordingly.")) : null,
    placement: "top"
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.tooltipContent
  }, /*#__PURE__*/React.createElement(RippleEffect, {
    className: "".concat((_params$row2 = params.row) !== null && _params$row2 !== void 0 && _params$row2.isEnrolmentScheduled ? classes.disabledCellText : classes.cellContent, " cellContent")
  }, (params === null || params === void 0 || (_params$row3 = params.row) === null || _params$row3 === void 0 ? void 0 : _params$row3.status) === RESIDENCY_STATUS_KEY_VALUES.Future ? "\u26A0\uFE0F ".concat(params.row.occupancy, "/").concat((_params$row$unitData4 = params.row.unitData) === null || _params$row$unitData4 === void 0 ? void 0 : _params$row$unitData4.occupancy) : params.row.occupancy)))));
});